import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/icon.d.ts').IconArrowDown}
 */
const IconArrowDown = ({
    height = 32,
    width = 32,
    className
}) => {
    return (
        <svg
            aria-hidden='true'
            className={className}
            fill='none'
            height={height}
            viewBox='0 0 20 20'
            width={width}
            xmlns='http://www.w3.org/2000/svg'>
            <path
                d='M9.66732 4.83398V13.8788L5.31961 9.53107L4.83398 10.0007L10.0007 15.1673L15.1673 10.0007L14.6817 9.53107L10.334 13.8788V4.83398H9.66732Z'
                fill='currentColor' />
        </svg>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default IconArrowDown;
